import { useTranslation } from "react-i18next";
import { FAQ_CATEGORIES, FAQ_QUESTIONS } from "./faqManifest";

function translateQuestion(t, question) {
  return {
    id: question.id,
    category: question.category,
    q: t(`questions.${question.id}.q`),
    a: t(`questions.${question.id}.a`),
  };
}

export function useFaq() {
  const { t } = useTranslation("help");

  function getCategoriesWithQuestions() {
    return FAQ_CATEGORIES.map((categoryId) => ({
      id: categoryId,
      title: t(`categories.${categoryId}`),
      questions: FAQ_QUESTIONS
        .filter((question) => question.category === categoryId)
        .map((question) => translateQuestion(t, question)),
    }));
  }

  function getHighlightedQuestions() {
    return FAQ_QUESTIONS
      .filter((question) => question.highlight)
      .map((question) => translateQuestion(t, question));
  }

  function search(query) {
    const needle = query.trim().toLowerCase();
    if (!needle) return [];
    return FAQ_QUESTIONS
      .map((question) => translateQuestion(t, question))
      .filter(({ q, a }) => q.toLowerCase().includes(needle) || a.toLowerCase().includes(needle));
  }

  return { getCategoriesWithQuestions, getHighlightedQuestions, search };
}
